import $ from 'jquery';
import screencheck from "./screencheck";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { power1, power2, power3, power4 } from "gsap";
gsap.registerPlugin(CustomEase);

CustomEase.create("hop", "M0,0,C0.56,0.032,0.248,1,1,1");

var animationDuration = 0.5,
// animationEase = 'power2.out';
    animationEase = 'hop';

// function headerSearch(element){
//     $(element).on('click', function(e) {
//         e.preventDefault();
//         $('body').addClass('overflowhidden');
//         $('.search-main').addClass('open');
//         $('.search-main').show(0, function () {
//             gsap.fromTo('.search-main', {transform: 'translateY(-100%)'}, {transform: 'translateY(0)', duration:animationDuration, ease:animationEase});
//         })
//         return false;
//     })

//     $('.search-close').on('click', function(e) {
//         e.preventDefault();
//         $('body').removeClass('overflowhidden');
//         $('.search-main').removeClass('open');
//         gsap.fromTo('.search-main', {transform: 'translateY(0)'}, {transform: 'translateY(-100%)', duration:animationDuration, ease:animationEase});
//         setTimeout(() => {
//             $('.search-main').hide();
//         }, 1000);
//         return false;
//     })

//     // Search btn on mobile
//     $(window).on('resize', function(){
//         if (screencheck(991)) {
//             $('.search-box #serch-btn').appendTo('.header-contact');
//         } else {
//             $('.header-contact #serch-btn').prependTo('.search-box');
//         }
//     }).resize();
// }

function focusAndOpenKeyboard(el, timeout) {
    console.log("focusAndOpenKeyboard");
    if(!timeout) {
        timeout = 100;
    }
    if(el) {
        console.log("el");
        // Align temp input element approximately where the input element is
        // so the cursor doesn't jump around
        var __tempEl__ = document.createElement('input');
        __tempEl__.style.position = 'absolute';
        __tempEl__.style.top = (el.offsetTop + 7) + 'px';
        __tempEl__.style.left = el.offsetLeft + 'px';
        __tempEl__.style.height = 0;
        __tempEl__.style.opacity = 0;
        // Put this temp element as a child of the page <body> and focus on it
        document.body.appendChild(__tempEl__);
        __tempEl__.focus();

        // The keyboard is open. Now do a delayed focus on the target element
        setTimeout(function() {
            el.focus();
            el.click();
            // Remove the temp element
            document.body.removeChild(__tempEl__);
        }, timeout);
    }
}
  

function headerModel(element){
    $(element).on('click', function(e) {
        var $this = $(this),
            $model = $this.data('model'),
            $body = $('body');
        //console.log($model);
        //e.preventDefault();
        $body.addClass('overflowhidden');
        $('.model-main').addClass('open');
        $('#'+$model).show(0, function () {
            gsap.fromTo('#'+$model, {transform: 'translateY(-100%)'}, {transform: 'translateY(0)', duration:animationDuration, ease:animationEase});
        })

        // Check if search input
        if($(element+'#serch-btn').length) {
           
            var newInputSearch = document.getElementById('header_search');
            //var modalFadeInDuration = 2000;
            focusAndOpenKeyboard(newInputSearch, 500); // or without the second argument
        }
        return false;
    })

    $('.model-close').on('click', function(e) {
        e.preventDefault();
        $('body').removeClass('overflowhidden');
        $(this).parents('.model-main').removeClass('open');
        gsap.fromTo($(this).parents('.model-main'), {transform: 'translateY(0)'}, {transform: 'translateY(-100%)', duration:animationDuration, ease:animationEase});
        setTimeout(() => {
            $(this).parents('.model-main').hide();
        }, 400);
        return false;
    })

    // Search btn on mobile
    $(window).on('resize', function(){
        if (screencheck(991)) {
            $('.search-box #serch-btn').appendTo('.header-contact');
        } else {
            $('.header-contact #serch-btn').prependTo('.search-box');
        }
    }).resize();
}

export default headerModel;